import { CDN_URL, EXTRA_REPORTS_IDS } from '@/const';

import { getClusterNameSubdomain } from './modeHelpers';

export default function prepareImageSrc(src: string, reportId = '') {
	// TODO: update later witj env
	const clusterNameSubdomain = 'test'; // getClusterNameSubdomain(true); //'test';

	if (!src) {
		return '';
	}

	if (src?.startsWith('http')) {
		return src;
	}

	// tricky sh*t for top 5 report examples for Mr. Allen
	if (reportId && EXTRA_REPORTS_IDS.includes(reportId)) {
		return `https://storage.googleapis.com/svcdn/${src}`;
	}

	// TODO: update with env
	return `${CDN_URL}/${src?.startsWith('/') ? src.slice(1) : src}`;
}
